import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IUniversity } from 'src/app/model/degree/iuniversity';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class DegreeService {

  constructor(private httpClient: HttpClient) { }

  public getUniversities(): Observable<IUniversity[]> {
    return this.httpClient.get<IUniversity[]>(environment.baseUrl + '/v1/getUniversities');
  }
}
